import { Pane, Heading, Paragraph } from 'evergreen-ui';
import HeroBanner from '../commons/HeroBanner';

export default function IlMetodoPage() {
  return (
    <Pane className="public-page-container">
      <HeroBanner 
        title="Il nostro approccio" 
        bgImage="/ilmetodo (2).png" 
      />
      
      <Pane maxWidth={800} marginX="auto" paddingY={60} paddingX={20} textAlign="center">
        <Paragraph size={600} marginBottom={24}>
          Lavoriamo attraverso la relazione educativa.
        </Paragraph>
        <Paragraph size={600} marginBottom={24}>
          Crediamo nella presenza costante, nell’ascolto e nella fiducia.
        </Paragraph>
        <Paragraph size={600} marginBottom={48} color="muted">
          Accompagniamo i ragazzi nel loro percorso di crescita, passo dopo passo.
        </Paragraph>
        
        <Heading size={700} marginBottom={32}>I nostri pilastri</Heading>
        <Pane display="flex" justifyContent="center" gap={16} flexWrap="wrap">
          <Pane hoverElevation={3} cursor="default" borderRadius={16} display="inline-flex" paddingX={16} paddingY={8} background="green500">
            <Paragraph color="white" fontWeight={600}>Presenza</Paragraph>
          </Pane>
          <Pane hoverElevation={3} cursor="default" borderRadius={16} display="inline-flex" paddingX={16} paddingY={8} background="green500">
            <Paragraph color="white" fontWeight={600}>Continuità</Paragraph>
          </Pane>
          <Pane hoverElevation={3} cursor="default" borderRadius={16} display="inline-flex" paddingX={16} paddingY={8} background="green500">
            <Paragraph color="white" fontWeight={600}>Relazione</Paragraph>
          </Pane>
          <Pane hoverElevation={3} cursor="default" borderRadius={16} display="inline-flex" paddingX={16} paddingY={8} background="green500">
            <Paragraph color="white" fontWeight={600}>Responsabilità</Paragraph>
          </Pane>
        </Pane>
      </Pane>
    </Pane>
  );
}